const loadingPage = (title) => `<!doctype html>
<html lang="it"><head><meta charset="utf-8"><title>${title}</title>
<style>body{margin:0;display:grid;place-items:center;min-height:100vh;font-family:Arial,sans-serif;background:#fff7ed;color:#9a3412}main{text-align:center}strong{display:block;font-size:20px;margin-bottom:8px}span{font-size:14px}</style>
</head><body><main><strong>${title}</strong><span>Preparazione del workspace in corso…</span></main></body></html>`;

/**
 * Reserve a browser tab synchronously from a user click. This prevents popup
 * blockers from rejecting the tab after the asynchronous API request ends.
 */
export function reservePraticaWorkspace(title = "Nuova pratica FiscoX") {
    const tab = window.open("", "_blank");
    if (!tab) return null;
    try {
        tab.document.open();
        tab.document.write(loadingPage(title));
        tab.document.close();
    } catch {
        // The tab is still usable even when the browser blocks document.write.
    }
    return tab;
}

export function openPraticaWorkspace(praticaId, reservedTab, fallbackNavigate) {
    const target = `/pratiche/${encodeURIComponent(praticaId)}`;
    if (reservedTab && !reservedTab.closed) {
        reservedTab.location.replace(`${window.location.origin}${target}`);
        return "new-tab";
    }
    if (typeof fallbackNavigate === "function") fallbackNavigate(target);
    else window.location.assign(target);
    return "same-tab";
}

export function closeReservedWorkspace(reservedTab) {
    if (reservedTab && !reservedTab.closed) reservedTab.close();
}
